import { Component } from '@angular/core';

@Component({
  selector: 'app-cm-user-detail',
  templateUrl: './cm-user-detail.component.html',
  styleUrls: ['./cm-user-detail.component.scss']
})
export class CmUserDetailComponent {

}
